





















import { Component, Vue } from 'vue-property-decorator';
import JobNewHeaderInputField from '@/components/jobNew/JobNewHeaderInputField.vue';
import JobNewDataInputField from '@/components/jobNew/JobNewDataInputField.vue';
import JobNewMainInputField from '@/components/jobNew/JobNewMainInputField.vue';
import JobNewSample from '@/components/jobNew/JobNewSample.vue';

@Component({
  components: {
    JobNewHeaderInputField,
    JobNewDataInputField,
    JobNewMainInputField,
    JobNewSample,
  },
})
export default class JobNewBase extends Vue {
  private occupation: Array<string> = [
    'エンジニアリング',
    'デザイナー',
    'フロントエンドエンジニア',
    'バックエンドエンジニア',
    'インフラエンジニア',
  ];

  private types: Array<string> = ['委任'];

  private skills: Array<any> = [
    'HTML',
    'CSS',
    'PHP',
    'JavaScript',
    'Java',
    'Swift',
    'Ruby',
    'C言語',
    'Python',
    'R',
    'Unity',
    'C++',
    'C#',
  ];

  private features: Array<any> = [
    'フレックス勤務',
    '自社サービスを展開している',
    'スタートアップ',
    'リモート勤務可能',
  ];

  private styles: Array<string> = ['出勤', 'リモート'];

  private view: string = 'header';

  private components: Array<
    typeof JobNewHeaderInputField | typeof JobNewDataInputField | typeof JobNewMainInputField
  > = [JobNewHeaderInputField, JobNewDataInputField, JobNewMainInputField];

  private componentIndex: { header: number; data: number; main: number } = { header: 0, data: 1, main: 2 };

  private onChangeView(viewItem: string) {
    this.view = viewItem;
  }

  private get jobNewBaseViewComponent() {
    switch (this.view) {
      case 'header':
        return this.components[this.componentIndex.header];
      case 'data':
        return this.components[this.componentIndex.data];
      case 'main':
        return this.components[this.componentIndex.main];
    }
  }
}
